export default "public/SK615562_88.svg";